import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import ApiService from 'redux/services/api-service';
import {CampaignTestControlEvent} from 'utils/types';

// Bound the number of events fetched; newest are returned first (ordering=-created_at).
const DEFAULT_EVENT_LIMIT = 100;

interface IState {
  events: CampaignTestControlEvent[];
  // Total number of events on the server (may exceed events.length when limited).
  count: number;
  loading: boolean;
}

export const testControlEventEndpoints = {
  listEvents: createAsyncThunk(
    'testControlEvents/listEvents',
    async (params: {campaign_id: number | string; event_type?: string; limit?: number}) => {
      const queryParams: Record<string, string> = {
        campaign_id: String(params.campaign_id),
        ordering: '-created_at',
        limit: String(params.limit ?? DEFAULT_EVENT_LIMIT),
      };
      if (params.event_type) queryParams.event_type = params.event_type;
      const response = await ApiService.get(`/test_control_events/?${new URLSearchParams(queryParams).toString()}`);
      return response.data;
    },
  ),
};

export const testControlEventSlice = createSlice({
  name: 'testControlEvents',
  initialState: {
    events: [],
    count: 0,
    loading: false,
  } as IState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(testControlEventEndpoints.listEvents.pending, state => {
        state.loading = true;
      })
      .addCase(testControlEventEndpoints.listEvents.fulfilled, (state, {payload}) => {
        state.loading = false;
        const results = payload.results ?? payload;
        state.events = results;
        state.count = payload.count ?? results.length;
      })
      .addCase(testControlEventEndpoints.listEvents.rejected, state => {
        state.loading = false;
      });
  },
});

export type TestControlEventSlice = {
  [testControlEventSlice.name]: ReturnType<(typeof testControlEventSlice)['reducer']>;
};
